import * as THREE from 'three';
class Line extends THREE.Line {
    props;
    constructor(data) {
        const geometry = new THREE.BufferGeometry();
        const material = new THREE.LineBasicMaterial({
            // vertexColors: true,
            color: 'red',
            linewidth: 100
        });
        super(geometry, material);
        this.props = data;
        // 画线基本代码
        const pointsArray = [];
        pointsArray.push(10, 20, 10);
        pointsArray.push(10, 200, 10);
        // const colors = [];
        // const r = 360;
        // for (let i = 0; i < pointsArray.length; i++) {
        //   colors.push((pointsArray[i] / r) + 0.5);
        //   colors.push((pointsArray[i] / r) + 0.5);
        //   colors.push((pointsArray[i] / r) + 0.5);
        // }
        this.position.set(100, 100, 5);
        geometry.setAttribute('position', new THREE.Float32BufferAttribute(pointsArray, 3));
        // geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
        geometry.computeBoundingSphere();
        // 修改线的粗细
        const _material = new THREE.LineBasicMaterial({
            color: Math.random() * 0xff0000,
            linewidth: 100
        });
        // 虚线
        const __material = new THREE.LineBasicMaterial({
            color: 'blue',
            linewidth: 1,
        });
        this.geometry = geometry;
        this.material = material;
    }
    dispose() {
        const { onDestory } = this.props;
        this.parent?.remove(this);
        this.material.dispose();
        this.geometry.dispose();
        if (onDestory && typeof onDestory === 'function') {
            onDestory(this);
        }
    }
}
export default Line;
